var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":_vm.leftText,"left-arrow":_vm.leftArrow,"fixed":_vm.fixed},on:{"click-left":_vm.clickLeft}})
}
var staticRenderFns = []

export { render, staticRenderFns }